/**
 * Session-scoped UI state for the frontend migration reminder.
 *
 * This store is intentionally not persisted. Dismissing the reminder survives
 * legacy SPA navigation, but a fresh login or page session shows it again.
 */
import { create } from "zustand";

interface FrontendMigrationUiState {
  bannerDismissed: boolean;
  dismissBanner: () => void;
}

export const useFrontendMigrationUiStore = create<FrontendMigrationUiState>(
  (set) => ({
    bannerDismissed: false,
    dismissBanner: () => set({ bannerDismissed: true }),
  })
);
